import { getCookies } from "cookies-next";
import { calculatePageType } from "./calculatePageType";
import { extractQuerystringParams } from "./extractQueryStringParams";

export function trackEvent(name: string, meta?: Record<string, unknown>): void {
  if (typeof window !== "undefined") {
    const cookies = getCookies();
    const fbc = cookies["_fbc"];
    const fbp = cookies["_fbp"];
    const ttclid = cookies["ttclid"];
    const ttp = cookies["_ttp"];

    window.analytics.track(name, {
      ...meta,
      browser: calculatePageType(),
      ...extractQuerystringParams(),
      authenticated_user: !!cookies["kz_user_token"],
      referrer: document?.referrer,
      fbc,
      fbp,
      ttclid,
      ttp,
    });
  }
}

declare global {
  interface Window {
    /**
     * segment analytics
     */
    analytics: any;
    dataLayer: any;
    gtag: (...args: any) => void;
  }
}
